export default "__VITE_ASSET__DxS_8sOL__"